const { ensureUserTestId } = require('@vp/ab-test-cookie');

const LS_IMPRESSION_KEY = 'exp-ab-impression';
const LS_TTL = 60000;

function debug(message) {
    if (
        window &&
        window.location &&
        (window.location.hostname.match(/localhost/) ||
            window.location.search.match(/debug=true/g))
    ) {
        console.log(`aa-impression: ${message}`);
    }
}

function getImpressionCache() {
    const newImpressionCache = {
        _ttl: new Date().getTime() + LS_TTL,
        testUserId: ensureUserTestId(),
        experiments: {}
    };
    try {
        const impressionCache = JSON.parse(
            localStorage.getItem(LS_IMPRESSION_KEY) || '{}'
        );
        if (
            impressionCache &&
            impressionCache._ttl > new Date() &&
            impressionCache.testUserId === ensureUserTestId()
        ) {
            return impressionCache;
        }
    } catch (error) {
        debug(`Error reading experiment impression cache: ${error}`);
    }
    return newImpressionCache;
}

function experimentAlreadyFired(experimentKey, variationKey) {
    const impressionCache = getImpressionCache();
    return impressionCache.experiments[experimentKey] === variationKey;
}

function setExperimentFired(experimentKey, variationKey) {
    let impressionCache = getImpressionCache();
    impressionCache.experiments[experimentKey] = variationKey;
    localStorage.setItem(LS_IMPRESSION_KEY, JSON.stringify(impressionCache));
}

async function fireImpression(
    experimentKey,
    variationKey,
    sdkKey,
    pageParameters
) {
    if (!experimentKey || !variationKey) {
        debug('Invalid input parameters for the fireImpression');
        return false;
    }
    let pageParametersSanitized = null;
    if (pageParameters) {
        if (
            pageParameters.pageName &&
            pageParameters.pageSection &&
            pageParameters.pageStage
        ) {
            pageParametersSanitized = pageParameters;
        } else {
            debug('Page parameters format is wrong');
        }
    }
    try {
        if (experimentAlreadyFired(experimentKey, variationKey)) {
            debug(`Experiment already fired: ${experimentKey}:${variationKey}`);
            return;
        }
        trackExperimentViewed(
            experimentKey,
            variationKey,
            sdkKey,
            pageParametersSanitized
        );
        setExperimentFired(experimentKey, variationKey);
        return true;
    } catch (error) {
        debug(`Error sending impression: ${error}`);
        return false;
    }
}

function trackExperimentViewed(
    experimentKey,
    variationKey,
    sdkKey,
    pageParameters
) {
    let trackProperties = {
        experimentName: experimentKey,
        variationName: variationKey,
        nonInteraction: 1,
        optimizelySdkKey: sdkKey,
        impressionEventVersion: 2
    };

    if (pageParameters) {
        trackProperties = {
            ...trackProperties,
            pageName: pageParameters.pageName,
            pageSection: pageParameters.pageSection,
            pageStage: pageParameters.pageStage
        };
    }

    if (window && window.tracking && window.tracking.track) {
        sendTrackEvent(trackProperties);
    } else {
        window.addEventListener('trackingReady', function () {
            sendTrackEvent(trackProperties);
        });
    }

    function sendTrackEvent(props) {
        // https://app.segment.com/vistaprint/protocols/tracking-plans/rs_1Uvr60Jg3ROZK4boO6jKvuUj2du
        window.tracking.track('Experiment Viewed', props);
    }
}

module.exports.fireImpression = fireImpression;
